import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EarnPointsQuery, EarnPointsService, MemberQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from 'ng-inline-svg';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc6 from '@ngx-translate/core';

function EarnPointsComponent_ng_container_1_ng_container_1_ng_template_5_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const earnPointSection_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", earnPointSection_r3.Description, " ");
} }
function EarnPointsComponent_ng_container_1_ng_container_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "h5", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 12);
    ɵngcc0.ɵɵelementStart(5, "button", 13);
    ɵngcc0.ɵɵelementStart(6, "div");
    ɵngcc0.ɵɵelement(7, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, EarnPointsComponent_ng_container_1_ng_container_1_ng_template_5_div_8_Template, 2, 1, "div", 15);
} if (rf & 2) {
    const earnPointSection_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", earnPointSection_r3.DisplayText, " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMapInterpolate1("dropdown-icon svg svg-", ctx_r6.svgColor, "");
    ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/down-icon.svg");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!earnPointSection_r3.Description);
} }
function EarnPointsComponent_ng_container_1_ng_container_1_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelement(2, "fgbcl-earn-points-card", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const earnPointsCard_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate2("content col-lg-", earnPointsCard_r12.Width, " col-", earnPointsCard_r12.MobileWidth, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("earnPointsCard", earnPointsCard_r12);
} }
function EarnPointsComponent_ng_container_1_ng_container_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, EarnPointsComponent_ng_container_1_ng_container_1_ng_template_6_ng_container_1_Template, 3, 5, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const earnPointSection_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", earnPointSection_r3.SectionItems);
} }
function EarnPointsComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ngb-accordion", 3, 4);
    ɵngcc0.ɵɵelementStart(3, "ngb-panel", 5, 6);
    ɵngcc0.ɵɵtemplate(5, EarnPointsComponent_ng_container_1_ng_container_1_ng_template_5_Template, 9, 6, "ng-template", 7);
    ɵngcc0.ɵɵtemplate(6, EarnPointsComponent_ng_container_1_ng_container_1_ng_template_6_Template, 2, 1, "ng-template", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("destroyOnHide", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cardClass", "earn-card-class");
} }
function EarnPointsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, EarnPointsComponent_ng_container_1_ng_container_1_Template, 7, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const earnPoints_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", earnPoints_r1);
} }
function EarnPointsCardComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "img", 8);
    ɵngcc0.ɵɵpipe(2, "contentImage");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r1.earnPointsCard.Image, "7"), ɵngcc0.ɵɵsanitizeUrl);
} }
function EarnPointsCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, EarnPointsCardComponent_div_0_div_2_Template, 3, 4, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "h5", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "div", 6);
    ɵngcc0.ɵɵpipe(7, "safeHtml");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.earnPointsCard.Image);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.earnPointsCard.DisplayText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(7, 3, ctx_r0.earnPointsCard.Description), ɵngcc0.ɵɵsanitizeHtml);
} }
class EarnPointsComponent {
    constructor(earnPointsQuery, earnPointsService, memberQuery) {
        this.earnPointsQuery = earnPointsQuery;
        this.earnPointsService = earnPointsService;
        this.memberQuery = memberQuery;
    }
    ngOnInit() {
        const userContext = this.memberQuery.getUserContext();
        this.earnPointsService.fetchEarnPoints(+userContext.populationId, +userContext.lcid, userContext.clubId).subscribe();
        this.earnPoints$ = this.earnPointsQuery.selectAll();
    }
}
EarnPointsComponent.ɵfac = function EarnPointsComponent_Factory(t) { return new (t || EarnPointsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.EarnPointsQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.EarnPointsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery)); };
EarnPointsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EarnPointsComponent, selectors: [["fgbcl-earn-points"]], inputs: { svgColor: "svgColor" }, decls: 3, vars: 3, consts: [[1, "earn-points-container"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["activeIds", "ngb-panel-i", 3, "destroyOnHide"], ["a", "ngbAccordion"], ["id", "ngb-panel-i", 3, "cardClass"], ["panel", ""], ["ngbPanelHeader", ""], ["ngbPanelContent", "", "class", "content-dropdown"], [1, "row", "mt-3"], [1, "col-lg-10", "col-11"], [1, "earn-sub-heading", "font-weight-bold", "pb-0", "text-left", "pl-0", "mb-0"], [1, "col-lg-2", "col-1"], ["type", "button", "ngbPanelToggle", "", 1, "btn", "py-1", "px-1", "mr-1", "dropdown-tog"], [3, "inlineSVG"], ["class", "mt-0 earn-section-description", 4, "ngIf"], [1, "mt-0", "earn-section-description"], [1, "row"], [3, "earnPointsCard"]], template: function EarnPointsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, EarnPointsComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.earnPoints$));
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.NgbAccordion, ɵngcc3.NgbPanel, ɵngcc3.NgbPanelHeader, ɵngcc3.NgbPanelContent, ɵngcc3.NgbPanelToggle, ɵngcc4.InlineSVGDirective, EarnPointsCardComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [""] });
EarnPointsComponent.ctorParameters = () => [
    { type: EarnPointsQuery },
    { type: EarnPointsService },
    { type: MemberQuery }
];
EarnPointsComponent.propDecorators = {
    svgColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EarnPointsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-earn-points',
                template: "<div class=\"earn-points-container\">\r\n  <ng-container *ngIf=\"earnPoints$ | async as earnPoints\">\r\n    <ng-container *ngFor=\"let earnPointSection of earnPoints\">\r\n      <ngb-accordion #a=\"ngbAccordion\" [destroyOnHide]=\"false\" activeIds=\"ngb-panel-i\">\r\n        <ngb-panel [cardClass]=\"'earn-card-class'\" #panel id=\"ngb-panel-i\">\r\n          <ng-template ngbPanelHeader>\r\n            <div class=\"row mt-3\">\r\n              <div class=\"col-lg-10 col-11\">\r\n                <h5 class=\"earn-sub-heading font-weight-bold pb-0 text-left pl-0 mb-0\">\r\n                  {{ earnPointSection.DisplayText }}\r\n                </h5>\r\n              </div>\r\n              <div class=\"col-lg-2 col-1\">\r\n                <button class=\"btn py-1 px-1 mr-1 dropdown-tog\" type=\"button\" ngbPanelToggle>\r\n                  <div>\r\n                    <div class=\"dropdown-icon svg svg-{{ svgColor }}\" [inlineSVG]=\"'assets/images/icons/down-icon.svg'\"></div>\r\n                  </div>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <div class=\"mt-0 earn-section-description\" *ngIf=\"!!earnPointSection.Description\">\r\n              {{ earnPointSection.Description }}\r\n            </div>\r\n          </ng-template>\r\n          <ng-template ngbPanelContent class=\"content-dropdown\">\r\n            <div class=\"row\">\r\n              <ng-container *ngFor=\"let earnPointsCard of earnPointSection.SectionItems\">\r\n                <div class=\"content col-lg-{{ earnPointsCard.Width }} col-{{ earnPointsCard.MobileWidth }}\">\r\n                  <fgbcl-earn-points-card [earnPointsCard]=\"earnPointsCard\"></fgbcl-earn-points-card>\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n          </ng-template>\r\n        </ngb-panel>\r\n      </ngb-accordion>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.EarnPointsQuery }, { type: ɵngcc1.EarnPointsService }, { type: ɵngcc1.MemberQuery }]; }, { svgColor: [{
            type: Input
        }] }); })();

class EarnPointsCardComponent {
    constructor() { }
    ngOnInit() { }
}
EarnPointsCardComponent.ɵfac = function EarnPointsCardComponent_Factory(t) { return new (t || EarnPointsCardComponent)(); };
EarnPointsCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EarnPointsCardComponent, selectors: [["fgbcl-earn-points-card"]], inputs: { earnPointsCard: "earnPointsCard" }, decls: 1, vars: 1, consts: [["class", "card card-body earn-card-body border-0 mb-3", 4, "ngIf"], [1, "card", "card-body", "earn-card-body", "border-0", "mb-3"], [1, "row", "h-100"], ["class", "col-3 col-sm-4 d-flex align-items-center justify-content-center", 4, "ngIf"], [1, "col-9", "col-sm-8"], [1, "earn-card-points-value", "text-white", "mb-0", "mt-2", "mt-lg-0"], [1, "earn-card-display", "line-height-18", 3, "innerHtml"], [1, "col-3", "col-sm-4", "d-flex", "align-items-center", "justify-content-center"], ["alt", "", 1, "earn-card-icon", 3, "src"]], template: function EarnPointsCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EarnPointsCardComponent_div_0_Template, 8, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.earnPointsCard);
    } }, directives: [ɵngcc2.NgIf], pipes: [ɵngcc5.SafeHtmlPipe, ɵngcc5.ContentImagePipe], styles: [""] });
EarnPointsCardComponent.ctorParameters = () => [];
EarnPointsCardComponent.propDecorators = {
    earnPointsCard: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EarnPointsCardComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-earn-points-card',
                template: "<div *ngIf=\"earnPointsCard\" class=\"card card-body earn-card-body border-0 mb-3\">\r\n  <div class=\"row h-100\">\r\n    <div class=\"col-3 col-sm-4 d-flex align-items-center justify-content-center\" *ngIf=\"earnPointsCard.Image\">\r\n      <img alt=\"\" class=\"earn-card-icon\" src=\"{{ earnPointsCard.Image | contentImage: '7' }}\" />\r\n    </div>\r\n    <div class=\"col-9 col-sm-8\">\r\n      <h5 class=\"earn-card-points-value text-white mb-0 mt-2 mt-lg-0\">\r\n        {{ earnPointsCard.DisplayText }}\r\n      </h5>\r\n      <div class=\"earn-card-display line-height-18\" [innerHtml]=\"earnPointsCard.Description | safeHtml\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { earnPointsCard: [{
            type: Input
        }] }); })();

class EarnPointsModule {
}
EarnPointsModule.ɵfac = function EarnPointsModule_Factory(t) { return new (t || EarnPointsModule)(); };
EarnPointsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EarnPointsModule });
EarnPointsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            InlineSVGModule,
            NgbModule,
            PipesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EarnPointsModule, { declarations: function () { return [EarnPointsComponent, EarnPointsCardComponent]; }, imports: function () { return [CommonModule,
        InlineSVGModule,
        NgbModule,
        PipesModule, ɵngcc6.TranslateModule]; }, exports: function () { return [EarnPointsComponent, EarnPointsCardComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EarnPointsModule, [{
        type: NgModule,
        args: [{
                declarations: [EarnPointsComponent, EarnPointsCardComponent],
                imports: [
                    CommonModule,
                    InlineSVGModule,
                    NgbModule,
                    PipesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [EarnPointsComponent, EarnPointsCardComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { EarnPointsCardComponent, EarnPointsComponent, EarnPointsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-club-earn-points.js.map